import { Spin } from "antd";
import { usePromiseTracker } from "react-promise-tracker";
import { useEffect, useState } from "react";

export default function Spinner({
  children,
  isSidebarCollapsed = true,
  isGuest = false,
}) {
  const { promiseInProgress } = usePromiseTracker();
  const [showSpinner, setShowSpinner] = useState(false);

  const classNames = !isSidebarCollapsed && !isGuest ? "without-sidebar" : "";

  useEffect(() => {
    let timeoutId;

    if (promiseInProgress) {
      setShowSpinner(true);
    } else {
      timeoutId = setTimeout(() => setShowSpinner(false), 200);
    }

    return () => clearTimeout(timeoutId);
  }, [promiseInProgress]);

  return (
    <Spin
      className={`global-spinner ${classNames}`}
      spinning={showSpinner}
      size="large"
    >
      {children}
    </Spin>
  );
}
